import styled from 'styled-components';

export const Wrapper = styled.div`
  z-index: 0;
  height: 100%;
  width: 100%;
  border: 0;
  position: absolute;
`;

export const ChatWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 4px;
  margin-top: 40px;
  padding: 0 16px;
  z-index: 0;
`;
